import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import InertiaTitle from 'inertia-title/vue3';
import { backendStorage } from '@/Plugins/GlobalStorePlugin.js';
import { setupI18n } from '@/Plugins/i18n.js';
import { createMitt } from '@/Plugins/Mitt.js';

createInertiaApp({
  progress: false,
  resolve: (name) => {
    const pages = import.meta.glob('./Pages/**/*.vue', { eager: true });
    return pages[`./Pages/${name}.vue`];
  },
  setup({ el, App, props, plugin }) {
    const globalProps = props.initialPage.props.global || {};

    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(createMitt)
      .use(backendStorage, globalProps)
      .use(setupI18n, { locale: props.initialPage.props.locale })
      .use(InertiaTitle);

    app.mount(el);
  },
}).then(() => {
  document.getElementById('app').removeAttribute('data-page');
});
